(function ($) {
    // check new reg token
    if (window.location.href.indexOf('newregtoken=') === -1) {
        return;
    }
    var hash = window.location.href.substr(window.location.href.indexOf('newregtoken=') + 12, 32);
    apiGetCall('user/reg_validate', { newregtoken: hash }, (error, result) => {
        if (error) {
            console.log(error);
            $('.js-error-login').text(result.error).removeClass('d-none');
            window.scrollTo(0, 0);
            setTimeout(function () {
                $('.js-error-login').addClass('d-none');
            }, 3200);
        }
        if (result.success == true) {
            $('.js-succes-login').removeClass('d-none');
            window.scrollTo(0, 0);
            setTimeout(function () {
                $('.js-succes-login').addClass('d-none');
            }, 3200);
        }

    });
})(jQuery);